// components/form/schemas/oneOne.js
const oneOneSchema = {
  title: "1_1 Stationary Combustion",
  addAPI: "cat1_1AddEmissionActivityAPI",
  cat: "cat1_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Activity Name",
      optionsAPI: "stationaryCombustionEmissionActivityAPI",
      required: true,
    },
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Name / Number",
      resetOnChange: false,
      required: true,
    },
    {
      key: "isBiomassActivity",
      level: 1,
      type: "trigger",
      label: "Biomass",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      tooltip: 'If biomass / biofuel / biogas is used, click "Yes".',
      required: true,
      resetOnChange: true,
    },
    {
      key: "isBiomassSeparate",
      level: 2,
      type: "trigger",
      label: "Report each greenhouse gas separately ?",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
      defaultValue: false,
      required: true,
      resetOnChange: true,
      showIf: {
        all: [
          { level: 1, key: "isBiomassActivity", eq: true },
          { level: 1, key: "isBiomassActivity", notEmpty: true },
        ],
      },
    },
  ],
};

export default oneOneSchema;
